(function () {
  'use strict';

  const TRANSITION_MS = 500;

  const state = {
    modal: null,
    player: null,
    closeButton: null,
    backdrop: null,
    previouslyFocused: null,
    isOpen: false,
  };

  function init() {
    const modal = document.querySelector('[data-pdp-video-modal]');
    if (!modal) return;

    state.modal = modal;
    state.player = modal.querySelector('[data-modal-player]');
    state.closeButton = modal.querySelector('[data-modal-close]');
    state.backdrop = modal.querySelector('[data-modal-backdrop]');

    state.closeButton.addEventListener('click', close);
    state.backdrop.addEventListener('click', close);
    document.addEventListener('keydown', onKeydown);

    window.PdpVideoModal = { open: open, close: close };
  }

  function open(triggerEl) {
    if (state.isOpen) return;

    const slideIndex = triggerEl.dataset.slideIndex;
    const template = document.querySelector(
      '[data-video-template][data-slide-index="' + slideIndex + '"]'
    );
    if (!template) return;

    state.previouslyFocused = document.activeElement;

    const clone = template.content.cloneNode(true);

    if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      const video = clone.querySelector('video');
      if (video) video.removeAttribute('autoplay');
    }

    state.player.appendChild(clone);

    state.modal.removeAttribute('hidden');
    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        state.modal.dataset.open = 'true';
        state.isOpen = true;
        state.closeButton.focus();
      });
    });
  }

  function close() {
    if (!state.isOpen) return;

    state.modal.dataset.open = 'false';
    state.isOpen = false;

    setTimeout(function () {
      state.modal.setAttribute('hidden', '');
      state.player.replaceChildren();
      if (state.previouslyFocused && typeof state.previouslyFocused.focus === 'function') {
        state.previouslyFocused.focus();
      }
      state.previouslyFocused = null;
    }, TRANSITION_MS);
  }

  function onKeydown(event) {
    if (!state.isOpen) return;

    if (event.key === 'Escape') {
      event.preventDefault();
      close();
      return;
    }

    if (event.key === 'Tab') {
      trapFocus(event);
    }
  }

  function trapFocus(event) {
    const focusables = state.modal.querySelectorAll(
      'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"]), video, audio'
    );
    if (focusables.length === 0) return;
    const first = focusables[0];
    const last = focusables[focusables.length - 1];
    if (event.shiftKey && document.activeElement === first) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault();
      first.focus();
    }
  }

  document.addEventListener('DOMContentLoaded', init);
})();
